<template>
  <div class="biz-clazz-picker-wrap"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="clazzList">
      <div class="body">
        <el-form size="mini"
                 label-width="80px"
                 label-suffix="：">
          <el-form-item label="教学点">
            <template v-if="siteInfo">
              <el-select :value="siteInfo.id"
                         disabled>
                <el-option :value="siteInfo.id"
                           :label="siteInfo.name"></el-option>
              </el-select>
            </template>
            <template v-else>
              <el-select v-model="siteId"
                         filterable
                         clearable
                         loading-text="教学点加载中..."
                         :loading="query.site.loading"
                         @visible-change="loadSites">
                <template v-if="query.site.dataList">
                  <el-option v-for="data in query.site.dataList"
                             :key="data.id"
                             :value="data.id"
                             :label="data.name"></el-option>
                </template>
              </el-select>
            </template>
          </el-form-item>
          <el-form-item label="年级">
            <template v-if="gradeInfo">
              <el-select :value="gradeInfo.id"
                         disabled>
                <el-option :value="gradeInfo.id"
                           :label="`${gradeInfo.name}级`"></el-option>
              </el-select>
            </template>
            <template v-else>
              <el-select v-model="gradeId"
                         filterable
                         clearable
                         loading-text="年级加载中..."
                         :loading="query.grade.loading"
                         @visible-change="loadGrades">
                <template v-if="query.grade.dataList">
                  <el-option v-for="data in query.grade.dataList"
                             :key="data.id"
                             :value="data.id"
                             :label="data.name"></el-option>
                </template>
              </el-select>
            </template>
          </el-form-item>
          <el-form-item label="班级">
            <el-select v-model="clazz"
                       value-key="id"
                       filterable
                       clearable>
              <template v-if="getClazzList">
                <el-option v-for="clazz in getClazzList"
                           :key="clazz.id"
                           :label="clazz.name"
                           :value="clazz"></el-option>
              </template>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <span>班级列表加载失败</span>
        <el-button type="text"
                   @click="clazzLoader">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../elements/Hint'
import {throttle} from 'throttle-debounce'
export default {
  name: 'ClazzPickerWrap',
  components: {
    Hint
  },
  props: {
    queryParams: Object,
    errorResolver: Function
  },
  data () {
    return {
      loading: false,
      siteInfo: null,
      gradeInfo: null,
      clazzList: null,
      query: {
        site: {
          loading: false,
          dataList: null
        },
        grade: {
          loading: false,
          dataList: null
        }
      },
      siteId: '',
      gradeId: '',
      clazz: null
    }
  },
  computed: {
    getClazzList () {
      let clazzList = this.clazzList
      if (clazzList) {
        return clazzList.filter(clazz => {
          if (clazz.site) {
            if (this.siteInfo) {
              if (clazz.site.id !== this.siteInfo.id) {
                return
              }
            } else if (this.siteId) {
              if (clazz.site.id !== this.siteId) {
                return
              }
            }
          }
          if (clazz.grade) {
            if (this.gradeInfo) {
              if (clazz.grade.id !== this.gradeInfo.id) {
                return
              }
            } else if (this.gradeId) {
              if (clazz.grade.id !== this.gradeId) {
                return
              }
            }
          }
          return true
        })
      }
    }
  },
  methods: {
    loadSites (val) {
      if (val) {
        if (!this.query.site.dataList) {
          this.query.site.loading = true
          this.$ajax({
            url: '/workspace/manager/portal/data/select/sites',
            method: 'post'
          }).then(response => {
            if (response.data) {
              this.siteInfo = response.data['site']
              this.gradeInfo = response.data['grade']
              this.query.site.dataList = response.data['sites'] || []
            }
          }, () => {
            this.$message.error('教学点数据加载失败')
          }).finally(() => {
            this.query.site.loading = false
          })
        }
      }
    },
    loadGrades (val) {
      if (val) {
        if (!this.query.grade.dataList) {
          this.query.grade.loading = true
          this.$ajax({
            url: '/workspace/manager/portal/data/select/grades',
            method: 'post'
          }).then(response => {
            if (response.data) {
              this.query.grade.dataList = response.data['grades'] || []
            }
          }, () => {
            this.$message.error('年级数据加载失败')
          }).finally(() => {
            this.query.grade.loading = false
          })
        }
      }
    },
    loadClazzList () {
      this.loading = true
      this.$emit('start')
      this.$ajax({
        url: '/workspace/manager/portal/data/select/clazzList',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.clazzList = response.data['clazzList'] || []
          this.$emit('ready')
        }
      }, () => {
        this.$message.error('班级数据加载失败')
      }).finally(() => {
        this.loading = false
        this.$emit('end')
      })
    },
    getClazz () {
      return new Promise((resolve, reject) => {
        let clazz = this.clazz
        if (clazz) {
          if (typeof this.errorResolver === 'function') {
            let err = this.errorResolver(clazz)
            if (err) {
              reject(err)
              return
            }
          }
          resolve(clazz)
        } else {
          reject(new Error('请先选择班级'))
        }
      })
    },
    resolveClazz (value, valueKey) {
      let clazzList = this.clazzList
      if (clazzList) {
        let clazz = clazzList.find(clazz => clazz[valueKey] === value)
        if (clazz) {
          if (typeof this.errorResolver === 'function') {
            let err = this.errorResolver(clazz)
            if (err) {
              return {
                type: 'fail',
                info: err.message,
                data: clazz
              }
            }
          }
          return {
            type: 'success',
            info: '选择成功',
            data: clazz
          }
        } else {
          return {
            type: 'fail',
            info: '班级不存在'
          }
        }
      } else {
        return {
          type: 'fail',
          info: '数据未加载'
        }
      }
    }
  },
  created () {
    this.clazzLoader = throttle(1000, this.loadClazzList)
  },
  mounted () {
    this.clazzLoader()
  }
}
</script>

<style lang="scss">
  .biz-clazz-picker-wrap {
    min-height: 120px;
    & > .body {
      .el-form {
        .el-form-item {
          margin-bottom: 12px;
          .el-form-item__label {
            font-size: 12px;
          }
          .el-form-item__content {
            .el-select {
              width: 100%;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .layout-hint {
      height: 120px;
    }
  }
</style>
